import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { GridHLNewPure, SimpleLoading, } from "../../pures";
import { BusinessAdministrationConfigurationsView } from "../../views";
import {
  HeaderHLPure,
  SearchBarHLPure,
  ButtonAddHLPure,
} from "../../pures";
import "./business-administration-panel.css";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description layout of the business administraion panel view. 
 * 
 */
const BusinessAdministrationPanelView = (props) => {
  const { clientCompany, userInformation, imageProfile } = props;
  const { t } = useTranslation();
  const [dataUser, setDataUser] = useState(clientCompany);

  const [selectedValueFilter, setSelectedValue] = useState("Todos");
  const [searchValue, setSearchValue] = useState("");
  const showStatus = useMediaQuery('(max-width: 1360px)')
  const showOtherOptions = useMediaQuery('(max-width: 1180px)')
  const showImgProfile = useMediaQuery('(max-width: 960px)')
  const [selectedUser, setSelectedUser] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDate, setSelectedDate] = useState({})
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const isMobile = useMediaQuery('(max-width:560px)')

  /**
   * @description Filter Function, convert to boolean
   * @status no delete
   * @param {*} value
   * @return {*} 
   */
  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "activo") return true;
      if (value.toLowerCase() === "inactivo") return false;
    }
    return value;
  };

  /** 
   * @description Filter Function, get selected date
   * @status no delete
   * @param {*} e
  */
  const filterDateChange = (dates) => {

    let object = { dateStart: dates.dateStart, dateEnd: dates.dateEnd };
    setSelectedDate(object);
    console.log(selectedDate);

  }

  /**
   * @description Filter Function, get selected value
   * @status no delete
   * @param {*} e
   */
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  //Update state information from grid
  useEffect(() => {
    setDataUser(clientCompany);
  }, [clientCompany]);

  //Filter Function, filter elements and update grid
  useEffect(() => {
    let usersCopy = [...clientCompany];
    let dataUpadate = usersCopy.filter(
      (user) => user.company.status === selectedValueFilter
    );
    setDataUser(dataUpadate);
  }, [selectedValueFilter]);


  /**
   * @description Search Function, get value search input
   * @status no delete
   * @param {*} e
   */
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  //Search Function, search elements and update grid
  useEffect(() => {
    let usersCopy = [...clientCompany];
    let dataUpdateFilter =
      selectedValueFilter === "Todos"
        ? clientCompany
        : usersCopy.filter((client) => client.status === selectedValueFilter);



    let dataUpdateSearch = dataUpdateFilter.filter((client) => {
      return (
        client.clientName.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      );
    });

    if (selectedDate.dateStart && selectedDate.dateEnd) {
      console.log(selectedDate, "date")
      const startDate = new Date(selectedDate.dateStart);
      const endDate = new Date(selectedDate.dateEnd);
      endDate.setHours(23, 59, 59, 999); // Include the whole end date day

      // Filter based on date range
      let dataUpdateDate = dataUpdateSearch.filter((client) => {
        let dateModification = new Date(client.updatedDate);
        console.log(dateModification, "datemodification");
        console.log(startDate, "startDate");
        console.log(endDate, "endDate");
        return dateModification.getTime() >= startDate.getTime() && dateModification.getTime() <= endDate.getTime();
      })
      setDataUser(dataUpdateDate);
    }
    else {
      setDataUser(dataUpdateSearch);
    }
  }, [searchValue, selectedValueFilter, selectedDate]);


  /**
   * @status no delete
   * @return {*} 
   */
  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser;
    switch (name) {
      case "":
        return t("businessAdministrationPanelView.title");
      case "Domicilio empresa":
        return (
          t("businessAdministrationPanelView.businessAddress") +
          " " +
          selectedUser.clientName
        );
      case "Certifica SAT":
        return (
          t("businessAdministrationPanelView.certifiesSAT") +
          " " +
          selectedUser.clientName
        );
      case "Inhabilitar empresa":
        return (
          t("businessAdministrationPanelView.disableCompany") +
          " " +
          selectedUser.clientName
        );
      case "Ver detalle/Editar":
        return t("businessAdministrationPanelView.seeDetail");
      case "Agregar nueva empresa":
        return t("userAdministrationView.saveUserTitle");
      default:
        return t("businessAdministrationPanelView.title");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail]);

  return (
    <div className="businessAdministrationPanelView-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          spacing={4}
          className="businessAdministrationPanelView-container"
        >
          <Grid
            container
            className="businessAdministrationPanelView-body"
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          >
            {showDetails && nameComponentUser ? (
              <BusinessAdministrationConfigurationsView
                nameComponentUser={nameComponentUser}
                selectedUser={selectedUser}
                hideShowDetails={() => {
                  setShowDetails(false);
                  setNameComponentUser("");
                  setHeaderTitleinDetail({ clicked: false, name: "" });
                }}
                toggleCompleted={props.toggleCompleted}
                token={props.token}
                setHeaderTitleinDetail={setHeaderTitleinDetail}
                forceRefresh={props.forceRefresh}
                validators={props.validators}
                optionsTypeBusiness={props.optionsTypeBusiness}
                optionsBusinessTurnover={props.optionsBusinessTurnover}
                contries={props.contries}
                clientCompany={clientCompany}
                showErrorRequesting={props.showErrorRequesting}
                showLoadingRequesting={props.showLoadingRequesting}
                showCompletedRequesting={props.showCompletedRequesting}
                showWarningRequesting={props.showWarningRequesting}
                message={props.message}
                toggleWarningRequesting={props.toggleWarningRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}
                toggleCompletedModel={props.toggleCompletedModel}
                onChangeImgProfile={props.onChangeImgProfile}
                resetImageProfile={props.resetImageProfile}
                setShowDetails={setShowDetails}
                setNameComponentUser={setNameComponentUser}
                userInformation={userInformation}
                imageProfile={imageProfile}
              />
            ) : (
              <>
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sm={12}
                  className="businessAdministrationPanelView-header"
                >
                  <HeaderHLPure
                    title={t("businessAdministrationPanelView.title")}
                  />
                </Grid>
                {/*Container primera seccion de items, fila*/}
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="businessAdministrationPanelView-navbar"
                >
                  {/*Cada componente puro, estara envuelto en un grid item */}
                  <Grid
                    item
                    lg={5}
                    md={4}
                    xs={12}
                    sm={12}
                    className="businessAdministrationPanelView-buttonHLPure"
                  >
                    <ButtonAddHLPure
                      nameBtn={"Agregar nueva empresa"}
                      iconAdd
                      onClickBtn={() => {
                        setNameComponentUser("Agregar nueva empresa");
                        setShowDetails(true);
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={3}
                    md={4}
                    xs={12}
                    sm={12}
                    className="businessAdministrationPanelView-searchHLPure"
                  >
                    <SearchBarHLPure
                      placeholder="Buscando empresas"
                      onSearchChange={(e) => searchChange(e)}
                      labelFilter="Filtrar por"
                      options={props.optionsFilter}
                      nameOption="status"
                      statusValueFilter={selectedValueFilter === true ? "Activo" : selectedValueFilter === false ? "Inactivo" : "Todos"}
                      optionsValue={"Todos"}
                      onFilterDate={filterDateChange}

                      onFilterChange={(e) => filterChange(e)}
                    />
                  </Grid>
                  {/* <Grid
                    item
                    lg={3}
                    md={4}
                    xs={12}
                    sm={12}
                    className="businessAdministrationPanelView-filterHLPure "
                  >
                    <FilterHLPure
                      labelFilter="Filtrar por"
                      options={props.optionsFilter}
                      nameOption="status"
                      valueItem={"Todos"}
                      optionsValue={"Todos"}
                      onFilterChange={(e) => filterChange(e)}
                    />
                  </Grid> */}
                </Grid>
                <Grid
                  item
                  className="businessAdministrationPanelView-gridContainer"
                >
                  <GridHLNewPure
                    dataGrid={dataUser}
                    skip={0}
                    take={6}
                    fieldSubtitleCol1={!showStatus ? "lastModificationDate" : ""}
                    textSubtitle={!showStatus ? "Última modificación el " : ""}
                    fieldImg={"imgProfile"}

                    // column widths specified
                    widthCol1="40%"
                    widthCol2="20%"
                    widthCol4="40%"


                    //header classnames, describe the styling for headers
                    headerClassNameCol1={"businessAdministrationPanelView-header-col-1"}
                    headerClassNameCol4={"businessAdministrationPanelView-header-col-4"}


                    //title of Cols
                    titleCol1="Empresas"
                    titleCol2="Características"
                    titleCol4="Acciones"

                    //field Name of columns
                    fieldNameCol1="clientName"
                    fieldNameCol2="status"

                    // Cell Action Buttons 
                    iconOneActive={!showOtherOptions}
                    iconThirdActive={!showOtherOptions}
                    iconFifthActive
                    labelOneActions={t("businessAdministrationPanelView.businessAddress")}
                    labelThirdActions={"Inhabilitar empresa"}
                    labelFifthActions={"Ver detalle/Editar"}
                    widthHeaderCol1={"gridHLPure-cellItemStylesTh1"}
                    widthHeaderCol2={"gridHLPure-cellItemStylesTh2"}
                    widthHeaderCol3={"gridHLPure-cellItemStylesTh3"}
                    widthHeaderCol4={"gridHLPure-cellItemStylesTh4"}
                    styleCol1={"gridHLPure-businessAdministration-cellItemStylesCol1"}
                    styleCol2={"gridHLPure-businessAdministration-cellItemStylesCol2"}
                    styleCol3={"gridHLPure-cellItemStylesCol3"}
                    styleCol4={"gridHLPure-businessAdministration-cellItemStylesCol4"}
                    activeDialog1={false}
                    iconAvatar={!showImgProfile}
                    onSelectedItem={setSelectedUser}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}

                  />
                </Grid>
              </>
            )}
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default BusinessAdministrationPanelView;
